module.exports = __webpack_public_path__ + "static/media/tablefabric.1989e098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tablefabric.jpg
// module id = 669
// module chunks = 0